import axios from 'axios'

class UsersQueries {
    fetchUsers(queryString = '') {
        const url = `/users/users${queryString ? `?${queryString}` : ''}`
        return axios.get(url)
    }

    fetchUserById(userId) {
        return axios.get(`/users/users/${userId}`)
    }

    createUser(userData) {
        return axios.post('/users/users', userData)
    }

    updateUser(userId, userData) {
        return axios.patch(`/users/users/${userId}`, userData)
    }

    getProductionDepartments(query = '') {
        return axios.get(`/production-departments/dicts/production-departments${query}`)
    }

    getStopCardProductionDepartments(query = '') {
        return axios.get(`/production-departments/dicts/card-stop-production-departments${query}`)
    }

    getUserPositions() {
        return axios.get('/users/dicts/user-positions')
    }

    getUserSquads() {
        return axios.get('/users/dicts/user-squads')
    }

    getUserRoles() {
        return axios.get('/users/user-permission-roles')
    }

    findUsers(paginate, query) {
        return axios.get(`/users/users${paginate}&search=${query}`)
    }

    findActiveUsers(paginate, query) {
        return axios.get(`/users/users${paginate}&isActive=true&search=${query}`)
    }

    receiveUsers(paginate, query, search) {
        return axios.get(`/users/users${paginate}${query}&search=${search}`)
    }
}

export default new UsersQueries()
